import { render, staticRenderFns } from "./PriceDefinition.vue?vue&type=template&id=0c20af1a&scoped=true"
import script from "./PriceDefinition.vue?vue&type=script&lang=js"
export * from "./PriceDefinition.vue?vue&type=script&lang=js"
import style0 from "./PriceDefinition.vue?vue&type=style&index=0&id=0c20af1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20af1a",
  null
  
)

export default component.exports